import { useContext, useEffect } from "react";
import { Backdrop, Box, CircularProgress, Stack } from '@mui/material';
import { BranchRead, ToolUser } from "../../../global/API";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { removeDuplicates } from "../../../../../core/validator/Validator";
import { Thead } from "./Thead";
import { Tbody } from "./Tbody";
import { Tfooter } from "./Tfooter";

import { FeatureIdState } from "../../../toolUsage/global/GlobalFcn";
import { CreateFeatureLogs } from "../../../global/API";

export const Index = () => {
    const { tool_state, setup_state, report_state } = useContext(ToolContext)
    const { __SESSION } = tool_state
    const { branchData, toolUser } = setup_state
    const {form, generateForm, salesBranchData, salesBranchList} = report_state

    const tool_id =  process.env.REACT_APP_TID_BIZ;

    const inputChangeHandler = async(e, val, key) => {
        let name
        let value
        if (key === 'branch_id' || key === 'user_id' ) {
            name = key;
            value = (val === null ? 0 : val.id);
        }else{
            name = e.target.name
            value = e.target.value
        }
        form.set({...form.data, [name]:value})
        salesBranchData.set([])
        generateForm.set((prev) => ({...prev, infiniteLoad:false, offset:0}))
    }

    const __init = async() => {
        let res = await BranchRead(__SESSION.data.uaccess[0].company_id, 'active')
        if (res) branchData.set([{id:0, name:'All', code:'000', active:1}, ...res])
        let res_user = await ToolUser(__SESSION.data.uaccess[0].company_id)
        let data = res_user.users.filter(v=>{return v.active === 1})
        const uniqueData = removeDuplicates(data);
        if (res_user) toolUser.set([{id:0, first_name:'All', last_name:'', active:1}, ...uniqueData]) 
    }

    const SendFeatureLogs = async()=>{
        let body = {
            aid: __SESSION.data.ainfo.aid,
            path: `${FeatureIdState('reports')}->1`,
            feature_id: 1,
            feature_name: "branch-sales-report",
            tid: tool_id,
            company_id: __SESSION.data.uaccess[0].company_id,
            action: 2
        }
        await CreateFeatureLogs(body)
    }

    useEffect(() => {
        __init()
        SendFeatureLogs()
        //eslint-disable-next-line
    }, [])

    return (
        <>
            <Thead inputChangeHandler={inputChangeHandler} />
            <Tbody salesBranchList={salesBranchList.data} generateForm={generateForm.data}/>
            <Tfooter salesBranchList={salesBranchList.data}/>
            <Backdrop open={generateForm.data.infiniteLoad} sx={{zIndex: '1300'}}>
                <Box height="150px" width="100%" display="flex" alignItems="center" justifyContent="center">
                    <Box height="100%" width="270px" borderRadius="12px" display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={3}>
                        <Stack sx={{ color: 'grey.300' }} spacing={2} direction="row">
                            <CircularProgress color="inherit"  />
                        </Stack>
                        <Box color="#fff">Fetching data ...</Box>
                    </Box>
                </Box>
            </Backdrop>
        </>
    )
}